export default {
  // just for display only, because the BE logic require audience emoji to process quiz answer :))
  // Avoid using it if u need to pass audience emoji to payload for api call
  audienceEmoji: (state, _, __, rootGetters) => {
    const isShownEmojiAvatar = rootGetters['presentationSettings/isShownEmojiAvatar']
    const audienceEmoji = state.audienceEmoji || ''
    return isShownEmojiAvatar ? audienceEmoji : ''
  },
  canUseSelfPacedSession: (state, getters) => {
    return Boolean(state.presentation?.audiencePacing
      && !state.presentation.teamPlay
      && getters['featureToggles/canUseSelfPacedLivestats']
      && getters['leaderboard/canUseNewLeaderboard'])
  },
  selfPacedAttempt: (state, getters) => {
    if (!getters.canUseSelfPacedSession) {
      return null
    }
    return state.selfPacedAttempt
  },
}
